
import { Component, Vue, Prop } from "vue-property-decorator";
import NewsItem from "./components/NewsItem.vue";
import { getNewsList } from "@/apis/about";
import Pagination from "@/components/pagination.vue";
import Breadcrumb from "@/components/Breadcrumb/index.vue";
import { generateMetaInfo } from "@/utils/seo";
@Component({
  components: {
    NewsItem,
    Pagination,
    Breadcrumb
  }
})
export default class News extends Vue {
  get metaInfo() {
    return generateMetaInfo({
      title: "光华动态 | 光华活动资讯、大事记与行业洞察 - 光华赋能",
      description:
        "光华赋能动态，涵盖线下活动资讯、思想碰撞与共同成长、光华大事记。二十余年专业企业经营研究，高维发展、全面赋能、长期陪跑，分享企业经营管理洞察与实践。",
      keywords:
        "光华动态,光华资讯,企业活动,管理资讯,行业洞察,光华大事记,企业经营,光华赋能",
      path: "/news",
      breadcrumb: [
        { name: "首页", url: "/" },
        { name: "关于光华" },
        { name: "光华动态" }
      ]
    });
  }

  total = 1;
  page = 1;
  per_page = 12;
  list: any = [];
  index: any = 0;
  List = [
    { title: "关于光华", url: "" },
    { title: "光华动态", url: "" }
  ];
  newsArr = [
    { year: "2025年", content: "“大增长——方永飞年度演讲暨EMBA校友日”等活动" },
    { year: "2024年", content: "“专业主义——方永飞年度演讲暨EMBA校友日”" },
    {
      year: "2023年",
      content:
        "“光华BLM 项目”正式启动、  “光华MBA”正式推出成功举办“人人时代——2023浙江省企业人才发展高峰论坛”、“走进钉钉——企业数字化管理私享会”等活动"
    },
    {
      year: "2022年",
      content:
        "光华赋能成为钉钉战略合作伙伴“微学SaaS”入驻钉钉、“绩效飞轮®”全面升级并入驻钉钉、“BLM绩效飞轮®”成功上线并入驻钉钉由光华赋能、钉钉共同发起的“共创会数字化转型联盟”正式启动成功举办“让进步发生——2022企业数字化转型高峰论坛”、“人即人效——2022第十四届浙江省人力资源高峰论坛”、“开放的力量——方永飞年度演讲暨EMBA校友日”等活动"
    },
    {
      year: "2021年",
      content:
        "“微学”产品升级为“微学SaaS”、全面升级推出“共同体组织AI”一体化组织数字化平台成功举办“浙江省企业人才发展高峰论坛”、“2021浙江省企业新营销高峰论坛”、“2021企业数字化转型高峰论坛”、“第十三届浙江省人力资源高峰论坛”等活动"
    },
    {
      year: "2020年",
      content:
        "光华管理研究院正式成立、上线“共建小生态”小程序营销工具、共创会EMBA升级成功举办：“2020（中国·杭州）直播电商峰会”、“2020（第二届）共创企业家戈壁挑战赛”等活动"
    },
    {
      year: "2019年",
      content:
        "光华商学院正式成立、光华职业经理人EMBA正式开班、上线“光华商学”产品（原集盒大学/集盒商学）、光华励源团建事业部正式成立“共创会”与“和基律师”达成战略合作成功举办：“浙江省企业人才发展高峰论坛”、“共创会2019年度战略高峰论坛”、“2019（第一届）共创企业家戈壁挑战赛”、“第十一届浙江省人力资源高峰论坛”等活动"
    },
    {
      year: "2018年",
      content:
        "“共创会EMBA项目”正式启动、上线“微学”产品召开2018光华年度企业家高峰论坛、“人才发展与组织赋能暨企业学习官发布”论坛、“新零售时代人才发展与组织变革”高峰论坛、“共创会2018年度战略高峰论坛”、“第十届浙江省人力资源高峰论坛”等活动"
    },
    {
      year: "2017年",
      content:
        "超越创新-决胜未来--2017-2018浙江企业人才发展高峰论坛\n2017时代光华ELP5.0产品发布会暨构建企业员工知识服务生态行业峰会\n2017第九届（中国-杭州）人力资源高峰论坛暨HR3.0再造\n感性的力量--100家铁军联盟蓄势待发高峰论坛"
    },
    {
      year: "2016年",
      content:
        "2016（中国-杭州）主题论坛一网红经济+微商论道\n互联网时代下的新组织行为学高峰论坛\n2015-2016互联网+高峰论坛-回到原点-互联网革命的终极密码论坛隆重举行\n2016（中国-杭州）第八届人力资源高峰论坛"
    },
    {
      year: "2015年",
      content:
        "荣获2015浙江省电子商务百强电子商务模式创新10强企业/被评为2014年度浙江省优秀管理咨询与培训单位"
    },
    {
      year: "2014年",
      content:
        "杭州时代光华&步步为赢乔迁至西溪科创园8幢/步步为赢入选浙江省首批两化融合第三方服务机构\n承办2014年（中国-杭州）电子商务发展论坛\n中小企业管理联盟正式升级为共创会，搭建总裁连接智慧与资源的首选商圈平台"
    },
    {
      year: "2013年",
      content:
        "步步为赢应邀参加中国杭州第七届电子信息博览会\n2013（中国-杭州）卓越管理高峰论坛19日隆重举行"
    },
    {
      year: "2012年",
      content:
        "杭州步步为赢管理科技有限公司网站全新上线/共同体GTT企业云管理平台新版应用/第一届嘉兴市人力资源高峰论坛暨企业学习与发展大会顺利召开\n中共翠苑街道九莲社区杭州时代光华教育发展有限公司支部委员会成立大会\n步步为赢教育科技集团官方旗舰店上线"
    },
    {
      year: "2011年",
      content: "杭州时代光华董事长方永飞老师被聘为浙江大学主讲教授"
    },
    {
      year: "2010年",
      content:
        "荣获“二零一零年度中国最受欢迎的专业培训机构”称号、荣获“二零一零年度中国区域最受欢迎的培训机构”称号"
    },
    {
      year: "2009年",
      content: "杭州时代光华绍兴运营中心成立/杭州时代光华金华运营中心成立"
    },
    {
      year: "2008年",
      content: "第一届浙江省HR精英联谊会暨浙江省HR精英俱乐部成立典礼"
    },
    { year: "2007年", content: "杭州时代光华客户服务部正式成立" },
    { year: "2006年", content: "正式开办大型公开课" },
    { year: "2005年", content: "杭州时代光华方永飞任北京时代光华总经理" },
    { year: "2004年", content: "浙江省青年企业家1+1提升工程战略合作单位" },
    { year: "2003年", content: "杭州时代光华成立" }
  ];
  created() {
    if (this.$route.query.index) {
      this.index = this.$route.query.index;
    }
    this.newsList();
  }
  handlePageChange(val: any) {
    this.page = val.page;
    this.newsList();
  }
  async newsList() {
    const { data, total } = await getNewsList({
      page: this.page,
      per_page: this.per_page
    });
    this.list = data;
    this.list.map((item: any) => {
      item.pic = item.pic ? item.pic : "/gh_website/img-default.png";
    });
    this.total = total;
    // if (this.index > 0) {
    //   this.$nextTick(() => {
    //     window.location.hash = "#li" + this.index;
    //   });
    // }
  }
  clickNews(item: any) {
    this.$router.push(`/news-detail?id=${item.id}&page=${this.page}`);
  }

  mounted() {
    const metaTag1 = document.createElement("meta");
    metaTag1.setAttribute("name", "keywords");
    metaTag1.setAttribute(
      "content",
      "光华介绍，光华师资，光华动态，客户案例，效果看得见，"
    );
    document.head.appendChild(metaTag1);
    const metaTag2 = document.createElement("meta");
    metaTag2.setAttribute("name", "description");
    metaTag2.setAttribute(
      "content",
      "企业培训咨询数字化转型，找光华，企业培训咨询数字化转型 |，找光华，服务一万家企业绩效飞轮*应用实践，帮助一万家企业BLM科学经营T系统落地，到2035年，赋能陪跑企业合计GDP超一万亿规模，用科学经营助推企业高质量发展讲师说明：董权、霍振先、潘亦藩、蔡毅臣、杨波、方永飞 所有老师的名字动态说明：动态标题，客户案例说明：客户案例标题"
    );
    document.head.appendChild(metaTag2);
  }
}
